import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import { getFirebase } from "@/firebaseInit";
import store from "@/store";
import SalesList from "@/components/SalesList";
import SlotManagement from "@/components/SlotManagement";
import MenuManagement from "@/components/MenuManagement";
import MenuDetail from "@/components/MenuDetail";
import Fail from "@/components/Fail";

let router = new Router({
  routes: [
    {
      path: "/:teamId/sales",
      name: "SalesList",
      component: SalesList,
      meta: { requiresAuth: true }
    },
    {
      path: "/:teamId/slots",
      name: "SlotManagement",
      component: SlotManagement,
      meta: { requiresAuth: true }
    },
    {
      path: "/:teamId/menus",
      name: "MenuManagement",
      component: MenuManagement,
      meta: { requiresAuth: true }
    },
    {
      path: "/:teamId/menus/:mid",
      name: "MenuDetail",
      component: MenuDetail,
      meta: { requiresAuth: true }
    },
    {
      path: "/",
      name: "fail",
      component: Fail
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    const teamId = to.params.teamId;
    store.commit("SET_TEAMID", { teamId });
    const firebaseData = getFirebase(teamId);
    const firebaseApp = firebaseData.app;
    const currentUser = firebaseApp.auth().currentUser;
    if (!currentUser) {
      console.log("not login");
      if (Vue.cookies.get("session")) {
        // webViewから
        await loginWithCustomToken(Vue.cookies.get("session"), firebaseApp);
        console.log("login done");
        initData();
        next();
      } else {
        // webView以外は弾く
        if (process.env.NODE_ENV === "development") {
          await mockLogin(firebaseApp);
          initData();
          next();
        } else {
          return next({ path: "/" });
        }
      }
    } else {
      // login状態ならそのまま進む
      next();
    }
  } else {
    console.log("logined");
    next();
  }
});

async function mockLogin(app) {
  let email = "iso-frontale-sss@dinii.jp";
  let password = "6867frontale0404";
  await app
    .auth()
    .signInWithEmailAndPassword(email, password)
    .catch(function(error) {
      console.error("mock login error:", error.message);
    });
  return;
}

async function initData() {
  await store.dispatch("fetchShopUserInfo");
  await store.dispatch("fetchShopInfo");
  await store.dispatch("fetchReservations");
  await store.dispatch("fetchMenus");
  await store.dispatch("fetchSlot");
  return;
}

// function signOut() {
//   firebase
//     .auth()
//     .signOut()
//     .then(() => {}, error => {});
// }

async function loginWithCustomToken(token, app) {
  await app
    .auth()
    .signInWithCustomToken(token)
    .catch(error => {
      console.error("loginWithCustomToken error:", error);
    });
  return;
}

export default router;
